export default __webpack_public_path__ + "static/media/home-startup-blog-img-02.011d4fda.jpg";